import { Col, Form, Input, Row } from 'antd';
import { FormComponentProps } from "antd/lib/form";
import React from 'react';

const FormItem = Form.Item;
const { TextArea } = Input;

interface IProps extends FormComponentProps {
    creditBalance: string;
    currencySymbol: string;
}

class ManualChargeForm extends React.Component<IProps>{
    public render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form layout="vertical">
                <Row gutter={48}>
                    <Col span={8}>
                        <FormItem label='Current Credit Balance'>
                            {`${this.props.creditBalance}`}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={48}>
                    <Col span={12}>
                        <FormItem label={'Amount to Charge'}>
                            {getFieldDecorator('chargeAmount', {
                                rules: [
                                    { validator: this.validateAmount }
                                ],
                            })(<div>{this.props.currencySymbol} <Input placeholder='0.00' className="input" /></div>)}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label={`Amount To Deduct From Credit`}>
                            {getFieldDecorator('creditDeduction', {
                                rules: [
                                    { validator: this.validateAmount },
                                ],
                            })(<div>{this.props.currencySymbol} <Input placeholder='0.00' className="input" /></div>)}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={48}>
                    <Col span={24}>
                        <FormItem label='Notes'>
                            {getFieldDecorator('note', {
                                rules: [
                                    {
                                        message: 'Please enter a note explaining the charge',
                                        required: true,
                                        whitespace: true,
                                    },
                                ],
                            })(<TextArea rows={4} />)}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={48}>
                    <Col span={24}>
                        <p>
                            Scheduling payments is coming soon. This will process the payment immediately.
                        </p>
                        <p>
                            Warning! Clicking 'Submit' will charge the customer's credit card.
                        </p>
                        <p>
                            Type  <code><b>CONFIRM</b></code> to continue.
                        </p>
                        <FormItem>
                            {getFieldDecorator('confirmCheck', {
                                rules: [
                                    { validator: this.validateConfirmBox },
                                ],
                            })(<div><Input className="input"/></div>)}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }

    private validateAmount = (rule: any, value: any, callback: any) => {
        // Validates that the input contains only numbers with up to 2 decimal places (Ex: 10.10)
        const regex = /^\d+\.?\d{0,2}$/g;
        const currentValue = parseFloat(value);
        if (!(value && value.toString().match(regex))){
            callback('Please enter valid amount')
        } else if (currentValue < 0.00) {
            callback('Please enter valid amount')
        } else {
            callback();
        }
    }

    private validateConfirmBox = (rule: any, value: any, callback: any) => {
        if (!(value && value.toLowerCase() === 'confirm')){
            callback('Please enter confirmation text')
        } else {
            callback();
        }
    }
}

export default Form.create<IProps>()(ManualChargeForm);
